import { ProjectContents } from '@console/common/constants';
import APITable from '@console/components/project/selectionReport/APITable';
import type { AppState } from '@console/reducers';
import { getGifteeBoxConfigsForSelectionReport } from '@console/selectors/projectDetail/gifteeBoxSelectionReports';
import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';

const mapStateToProps = (state: AppState) => ({
  gifteeBoxConfigsForSelectionReport:
    getGifteeBoxConfigsForSelectionReport(state),
  onClickGifteeBoxConfig: (
    navigate: NavigateFunction,
    gifteeBoxConfigUrlCode: UrlCode
  ) => {
    const projectUrlCode = state.selectedProjectUrlCode;
    const url = `/console/projects/${projectUrlCode}/${ProjectContents.GIFTEE_BOX_CONFIGS}/${gifteeBoxConfigUrlCode}/${ProjectContents.EXCHANGE_REPORT}`;
    navigate(url);
  }
});

const mapDispatchToProps = () => ({});

export type APITablePropsMappedFromState = ReturnType<typeof mapStateToProps>;

export type APITablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(APITable);
